import React from 'react'

const PaymentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.977 17.264a.354.354 0 0 0 .021.027c.053.061.158.15.337.254.358.209.902.415 1.587.597 1.361.362 3.139.589 4.745.589a21.11 21.11 0 0 0 4.457-.495c.67-.154 1.237-.332 1.65-.52a2.44 2.44 0 0 0 .456-.261c.08-.062.109-.1.115-.11l.044-.114 1.196.456-.058.153-.006.012a1.598 1.598 0 0 1-.51.617 3.648 3.648 0 0 1-.706.41c-.52.238-1.18.44-1.895.604a22.396 22.396 0 0 1-4.743.528c-1.708 0-3.597-.24-5.074-.632-.734-.195-1.402-.437-1.901-.727a2.578 2.578 0 0 1-.665-.528 1.284 1.284 0 0 1-.334-.837c0-.694.5-1.2 1.02-1.531.546-.349 1.283-.622 2.119-.819l.125.531.346.644-.096.052-.082.02c-.76.178-1.344.409-1.723.65-.337.216-.41.37-.425.43Z"
        fill="url(#a)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.333 16.633a.64.64 0 0 1 .64.64v4.134c.136.091.35.204.666.323.46.175 1.05.336 1.72.473a22.79 22.79 0 0 0 4.308.435c1.386 0 2.987-.118 4.328-.347.671-.114 1.26-.253 1.718-.411a3.13 3.13 0 0 0 .647-.293v-4.133a.64.64 0 1 1 1.28 0v4.425a.64.64 0 0 1-.153.416c-.314.368-.835.614-1.355.795-.549.19-1.213.343-1.922.463-1.422.242-3.096.365-4.543.365-1.46 0-3.14-.171-4.563-.46a12.608 12.608 0 0 1-1.92-.531c-.52-.198-1.03-.458-1.337-.817a.64.64 0 0 1-.154-.415v-4.422a.64.64 0 0 1 .64-.64Z"
        fill="url(#b)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.535 21.105c-.154-.148-.411-.314-.787-.475l.504-1.177c.457.196.866.436 1.17.73.307.294.551.688.551 1.167h-1.28c0-.016-.005-.098-.158-.245Z"
        fill="url(#c)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.334 20.71a.64.64 0 0 1 .64.64v4.603a.64.64 0 0 1-.153.415c-.314.368-.835.615-1.355.795-.549.19-1.213.343-1.922.463-1.422.242-3.096.365-4.543.365-1.46 0-3.14-.171-4.563-.46A12.608 12.608 0 0 1 9.518 27c-.52-.198-1.03-.458-1.337-.817a.64.64 0 0 1-.154-.415v-3.334a.64.64 0 1 1 1.28 0v3.046c.136.091.35.204.666.324.46.175 1.05.336 1.72.472 1.34.273 2.934.435 4.308.435 1.386 0 2.987-.118 4.328-.346.671-.115 1.26-.253 1.718-.412.308-.107.516-.209.647-.293v-4.31a.64.64 0 0 1 .64-.64Z"
        fill="url(#d)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.31 7.966c.01.027.062.125.29.28.293.196.758.397 1.39.577 1.256.357 3.027.586 5.01.586 1.984 0 3.756-.23 5.011-.586.633-.18 1.098-.381 1.39-.578.229-.154.28-.252.29-.28-.01-.027-.061-.125-.29-.28-.292-.195-.757-.397-1.39-.577-1.255-.357-3.027-.586-5.01-.586-1.984 0-3.755.23-5.01.586-.633.18-1.098.382-1.39.578-.23.154-.28.252-.291.28Zm1.33-2.09c1.399-.397 3.294-.634 5.36-.634 2.068 0 3.963.237 5.361.635.695.197 1.304.444 1.754.746.427.287.86.728.86 1.343 0 .614-.434 1.055-.86 1.342-.45.302-1.059.549-1.754.746-1.398.398-3.293.635-5.36.635s-3.962-.237-5.36-.635c-.696-.197-1.304-.444-1.754-.746-.427-.287-.86-.728-.86-1.342 0-.615.433-1.056.86-1.343.45-.302 1.058-.549 1.753-.746Z"
        fill="url(#e)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.667 7.328a.64.64 0 0 1 .64.64v4.129c.136.091.35.204.666.324.46.175 1.05.336 1.72.472 1.34.273 2.934.435 4.308.435 1.386 0 2.987-.118 4.328-.346.671-.114 1.26-.253 1.718-.412.308-.106.516-.209.647-.292v-4.31a.64.64 0 1 1 1.28 0v4.602a.64.64 0 0 1-.153.416c-.314.367-.835.614-1.355.794-.549.19-1.213.343-1.922.464-1.422.242-3.096.364-4.543.364-1.46 0-3.14-.17-4.563-.46a12.608 12.608 0 0 1-1.92-.53c-.52-.199-1.03-.459-1.337-.817a.64.64 0 0 1-.154-.416V7.968a.64.64 0 0 1 .64-.64Z"
        fill="url(#f)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.87 12.277c-.155-.148-.412-.314-.788-.475l.504-1.177c.457.196.866.436 1.17.73.307.294.551.688.551 1.167h-1.28c0-.016-.005-.098-.158-.245Z"
        fill="url(#g)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.666 11.875a.64.64 0 0 1 .64.64v3.935a.64.64 0 0 1-.153.416c-.314.367-.835.614-1.355.794-.548.19-1.212.343-1.922.464-1.422.242-3.096.364-4.543.364-1.46 0-3.14-.17-4.563-.46a12.61 12.61 0 0 1-1.92-.53c-.52-.199-1.03-.458-1.337-.817a.64.64 0 0 1-.154-.416v-3.157a.64.64 0 0 1 1.28 0v2.87c.136.09.35.203.666.323.46.175 1.05.336 1.72.472a22.79 22.79 0 0 0 4.308.435c1.386 0 2.987-.118 4.328-.346.671-.114 1.26-.253 1.718-.411a3.19 3.19 0 0 0 .647-.293v-3.643a.64.64 0 0 1 .64-.64Z"
        fill="url(#h)"
      />
      <defs>
        <radialGradient
          id="a"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-162.222 14.956 8.592) scale(24.3903 48.2489)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="b"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-155.351 16.143 10.003) scale(25.6429 66.1317)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="c"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-139.43 16.303 6.39) scale(4.28125 14.3902)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="d"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-155.366 17.253 11.895) scale(25.6398 66.0942)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="e"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-161.064 14.999 3.725) scale(24.6398 51.4566)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="f"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-155.366 15.792 5.203) scale(25.6398 66.0942)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="g"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-139.43 15.339 1.73) scale(4.28125 14.3902)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="h"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-23.3063 -9.70864 23.44691 -56.28605 29.309 20.221)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default PaymentIcon